module.exports = __webpack_public_path__ + "media/images/image-bg-fedd579866a6bd69e94e45c37545d722.jpg";